import { render, staticRenderFns } from "./approvalConfig.vue?vue&type=template&id=007469aa&scoped=true"
import script from "./approvalConfig.vue?vue&type=script&lang=js"
export * from "./approvalConfig.vue?vue&type=script&lang=js"
import style0 from "./approvalConfig.vue?vue&type=style&index=0&id=007469aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007469aa",
  null
  
)

export default component.exports